import {defineRouting} from 'next-intl/routing';
import {createNavigation} from 'next-intl/navigation';
import config from './config';

/**
 * Note: This file uses the static config.ts file directly.
 * For dynamic configuration using site settings, the app would need
 * to be rebuilt or redeployed to take effect.
 * 
 * At runtime, after initialization, we still use the static config.
 * Currency conversion rates and other non-routing-related settings
 * can be updated from site settings without app restart.
 */
 
export const routing = defineRouting({
    locales: config.locales,

    defaultLocale: config.defaultLocale,

    pathnames: config.pathnames,
});

export const {Link, redirect, usePathname, useRouter, getPathname} =
  createNavigation(routing);

function buildHref(route: string, params?: Record<string, string>): string {
  if (!params) return route;
  return route.replace(/\[([^\]]+)\]/g, (_, key) => params[key] || '');
}

/**
 * Helper function to generate static path params for localized routes
 * This is for use with `generateStaticParams` functions in page.tsx files
 * 
 * This function handles routes both within and outside the config pathnames.
 * It's a wrapper around the native Next.js internationalization approach.
 * 
 * @returns Array of locale objects for all supported locales
 */
export function generateLocalizedStaticParams() {
  // Simply return all configured locales
  return config.locales.map((locale) => ({ locale }));
}

export { buildHref };